"use strict";

function _classCallCheck(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function _createClass(e, r, n) {
  return r && _defineProperties(e.prototype, r), n && _defineProperties(e, n), e;
}
var CriticalInput = require("./CriticalInput.service"),
  UrlMapper = function () {
    return _createClass(function e() {
      _classCallCheck(this, e);
    }, [{
      key: "getCredsForDomain",
      value: function (e) {
        var r = CriticalInput.URL_ENV_MAP,
          n = window.location.href,
          t = new URL(n).hostname.split(".")[0];
        return e[r[t]] ? e[r[t]] : e.devint;
      }
    }]);
  }();
module.exports = {
  UrlMapper: UrlMapper
};